//
//
//
//
//
//
//
//

import siteLogo from '@/assets/images/logo.png';
import siteLogoEn from '@/assets/images/logo-en.png';

export default {
  name: 'AppLogo',
  computed: {
    logo() {
     return this.logos[this.$i18n.locale]
    }
  },
  data: () => ({
    logos: {
      ru: siteLogo,
      en: siteLogoEn,
    },
  }),
};
